import { FunctionComponent, useCallback, useContext, useEffect, useState } from "react";
import styles from "./CheckoutPagamentoBoletoCod.module.css";
import { Header } from "../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import { useCheckout } from "../../context/CheckoutContext";

const CheckoutPagamentoBoletoCod: FunctionComponent = (
  {
    boletoData
  }
) => {
  const navigate = useNavigate();
  const params = useParams();
  const { cart, paymentType } = useCheckout();
  useEffect(() => {
    if (cart.length === 0) params.slug ? navigate(`/${params.slug}`) : navigate("/")
  }, [])
  const onPixContainerClick = useCallback(async(code: string) => {
    await navigator
    .clipboard
    .writeText(code)
  }, []);

  return (
    <div id="pix-area" translate="no">
    <div className={styles.checkoutPagamentoBoletoCod}>
      <div className={styles.header}>
        <Header path="none" screen="pix" />
      </div>
      <div className={styles.pix}>
        <div className={styles.info}>
          <div className={styles.textp}>
            <div className={styles.aguardandoPagamentoVia}>
              {paymentType === 'Pix' && 'Aguardando pagamento via PIX'}
              {paymentType === 'Boleto' && 'Aguardando pagamento via Boleto'}
            </div>
            <div className={styles.realizeOPagamento}>
              {paymentType === 'Pix' &&
                'Para facilitar o pagamento do seu Pix, utilize o Pix copia e cola abaixo. Validade de 30 minutos.'
              }
              {paymentType === 'Boleto' &&
                'Para facilitar o pagamento do seu boleto, utilize o código de barras abaixo.'
              }
            </div>
          </div>
          {
            boletoData?.barcode || boletoData?.pixCode ?
            <div className={styles.codBarras}>
              {paymentType === 'Boleto' &&
                <a
                  className={styles.download}
                  href={boletoData.url}
                  target="blank"
                >
                  Visualizar {paymentType}
                </a>
              }
              {paymentType === 'Pix' &&
                <img className={styles.icones3} alt="" src={boletoData.url} />
              }
              <div className={styles.parent}>
                <div className={styles.aguardandoPagamentoVia}>
                  {boletoData?.barcode || boletoData?.pixCode}
                </div>
                <button
                  type="button"
                  className={`${styles.aguardandoPagamentoVia}
                    ${styles.copiarCdigoWrapper}`}
                  onClick={() =>
                    onPixContainerClick(
                      boletoData?.barcode || boletoData?.pixCode
                    )
                  }
                >
                  COPIAR CÓDIGO
                </button>
              </div>
              <a className={styles.cta} href="https://conta.yelly.com.br/register" target="_blank" style={{
                textDecoration: 'none'
              }} rel="noreferrer">
                <img className={styles.icones3} alt="" src="/icones4.svg" />
                <button
                  type="button"
                  className={`${styles.copiarCdigoWrapper}
                  ${styles.aguardandoPagamentoVia}`}
                  style={{width: '100%'}}
                >Continuar para o seu cadastro</button>
                <img className={styles.icones1} alt="" src="/icones5.svg" />
              </a>
              <div className={styles.teEnviamosUmContainer}>
              <div className={styles.nordesteENorte520DiasT}>
                *Prossiga para a criação do seu cadastro e encaminhe documentos solicitados. O envio de sua maquininha ocorre após a aprovação do seu cadastro e criação de conta especial, feita por nós, na Pagbank.
              </div>
              </div>
              <a href="https://api.whatsapp.com/send?phone=5527996075780" target="_blank" rel="noreferrer"><img className={styles.logoYellyIcon} src="/whatz.svg" ></img></a>
            </div> : 
            <div className={styles.aguardandoPagamentoVia}>
              Gerando {paymentType.toLowerCase()}...
            </div>
          }
        </div>
        <div className={styles.vocPoderLerContainer}>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CheckoutPagamentoBoletoCod;
